module.exports = __webpack_public_path__ + "img/magnifying-black.fab788ce.svg";